<template>
<div>
  <v-tabs v-if="isWeChat" v-model="tab" centered>
    <v-tabs-slider></v-tabs-slider>

    <v-tab href="#tab-1" @click="setPaymentMethod(false)" class="pa-1">
      {{ $vuetify.lang.t('$vuetify.account.creditCard') }}
    </v-tab>

    <v-tab href="#tab-2" @click="setPaymentMethod(true)" class="pa-1">
      {{ $vuetify.lang.t('$vuetify.paymentDetails.wechat') }}
    </v-tab>
  </v-tabs>

  <div v-show="!usingWeChat" class="stripe">
    <div style="position: relative">
      <div class="stripeCard" id="card-element"> </div>
      <label v-if="animating" :class="animating">
        {{ $vuetify.lang.t('$vuetify.paymentDetails.cardNumber') }}
      </label>
    </div>

    <div v-if="errors.cardError" class="error--text" style="padding: 5px 10px 15px;" >
      {{errors.cardError}}
    </div>
  </div>

  <div v-if="isWeChat && usingWeChat" class="row middle-xs weChatRow">
      <div class="col-xs">
        {{ $vuetify.lang.t('$vuetify.paymentDetails.wechat') }} {{ $vuetify.lang.t('$vuetify.checkout.pay') }}
      </div>

      <div class="col-xs-2">
        <v-img :height="50" :width="50" src="/giftcard/img/wechat-pay-logo.png" />
      </div>
  </div>
</div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      tab: null,
      usingWeChat: false,

      stripe:  null,
      stripeCard: null,
      cardReady: false,

      errors: {},

      animating: false
    }
  },

  computed: {
    isWeChat() {
      const ua = navigator.userAgent.toLowerCase()

      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },

    stripeKey() {
      return this.isTest ? 'pk_test_yTuFHGcSGCBm65aYYT5Vt0Ee' : 'pk_live_ppArwjpEtPJBVq0xPuwlC3ro'
    },

    ...mapGetters([ 'isTest' ])
  },

  methods: {
    async mountStripe() {
      this.stripe = await loadStripe(this.stripeKey, { locale: window.i18n.locale });
      var stripeElement = this.stripe.elements();
      this.stripeCard = stripeElement.create('card', { hidePostalCode : true});
      this.stripeCard.hidePostalCode = true;

      const _this = this
      this.stripeCard.removeEventListener('change');
      this.stripeCard.addEventListener('change', function(event) {
        if (!_this.animating)
          _this.animating = 'animateUp'

        // Use the events complete flag to check when the user has entered their card details
        _this.cardReady = event.complete
        _this.$emit("update:cardReady", event.complete);

        if (event.error) {
          _this.$set(_this.errors, 'cardError', event.error.message)
        } else {
          _this.$delete(_this.errors, 'cardError')
        }
      });

      this.stripeCard.mount(document.getElementById('card-element'));
    },

    async retrieveStripeToken() {
      if (!this.usingWeChat) {
        return this.stripe.createPaymentMethod({ type : 'card', card : this.stripeCard}).then(result => {
          if(result.error) {
            this.$bus.$emit('showAlert', this.$vuetify.lang.t('$vuetify.paymentDetails.cardDetailsError'))
            return null
          } else {
            return result.paymentMethod.id;
          }
        });
      }
    },


    setPaymentMethod(val) {
      this.usingWeChat = val

      this.$emit("update:usingWeChat", val);
    },

    validate() {
      if (!this.usingWeChat && !this.cardReady) {
        this.$set(this.errors, 'cardError', this.$vuetify.lang.t('$vuetify.paymentDetails.cardDetailsMissing'))
      } else {
        this.$delete(this.errors, 'cardError')
      }
    }
  },

  mounted() {
    this.mountStripe()
  }
}
</script>

<style scoped>

  .stripeCard, .weChatRow {
    padding: 20px 5px;
    height: 60px;
    background-color:#F5F5F5 ;
    position: relative;
    border-radius: 16px;
  }
  .stripeCard {
    padding-left: 30px;
    padding-right: 30px;
  }
  .stripeCard:hover, .weChatRow:hover {
    border-color: black;
  }

  label {
    position: absolute;
    top: 22px;
    left: 25px;

    font-size: 14px;
    color: rgba(0,0,0,.6);

    padding: 0px 7px;
  }
  .animateUp {
    position: absolute;
    top: -5px;
    left: 25px;
    font-size: 12px;

    animation: moveUp 0.2s linear;
    background-color: white;
  }
  @keyframes moveUp {
    0% {    top: 22px; left: 25px; }
    100% {  top: -5px; left: 25px; }
  }

  .weChatRow {
    padding: 0px !important;
  }

  .weChatRow .col-xs-2 {
    min-width: 60px !important;
    max-width: 60px !important;
  }
</style>
